"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const uicon_link_fill_style_1 = __importDefault(require("./uicon.link.fill.style"));
class UiconLinkFill extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, size } = this.props;
            return (jsx_runtime_1.jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", viewBox: "0 0 32 32", "aria-hidden": "true", className: classes.root, style: { width: size, height: size } }, { children: [jsx_runtime_1.jsx("path", { d: "M20.373 13.029l-1.402-1.402 2.362-2.332a4.267 4.267 0 00-2.285-.67A4.312 4.312 0 0016 9.905L9.905 16a4.311 4.311 0 00-1.28 3.048c.007.809.239 1.6.67 2.285l2.332-2.346 1.402 1.402-2.362 2.316c.689.434 1.486.666 2.3.67a4.31 4.31 0 003.048-1.28L22.11 16a4.312 4.312 0 001.28-3.048 4.267 4.267 0 00-.685-2.285l-2.332 2.362z", className: classes.fill }, void 0),
                    jsx_runtime_1.jsx("path", { d: "M28.952 0H3.048A3.048 3.048 0 000 3.048v25.904A3.048 3.048 0 003.048 32h25.904A3.048 3.048 0 0032 28.952V3.048A3.048 3.048 0 0028.952 0zm-5.455 17.463l-6.095 6.095a6.31 6.31 0 01-4.48 1.86 6.415 6.415 0 01-3.718-1.22l-2.408 2.408-1.402-1.402 2.469-2.469a6.324 6.324 0 01.64-8.198l6.095-6.095a6.308 6.308 0 014.48-1.86 6.415 6.415 0 013.718 1.22l2.469-2.469 1.402 1.402-2.53 2.53a6.324 6.324 0 01-.64 8.198z", className: classes.fill }, void 0)] }), void 0));
        };
    }
}
UiconLinkFill.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    size: prop_types_1.default.number
};
UiconLinkFill.defaultProps = {
    size: null
};
exports.default = react_jss_1.default(uicon_link_fill_style_1.default)(UiconLinkFill);
//# sourceMappingURL=uicon.link.fill.js.map